import crypto from 'crypto';

export const generateUUID = () => {
  if (typeof window !== 'undefined' && window.crypto?.randomUUID) {
    return window.crypto.randomUUID(); // Tarayıcıda çalışır
  } else {
    return crypto.randomUUID(); // Node.js içinde çalışır
  }
};
